import { handleActions, combineActions } from "redux-actions";
import { AppState } from "../../../models";
import { AllLabelsAcionTypes } from "../../actions";

const allLabelsState: AppState.AllLabelsState = {
  loading: false,
  data: [],
};

export const AllLabelsReducer = handleActions(
  {
    /* tên trong action phải giống khi sử dụng nhưng khác là dùng camelCase */
    [combineActions(
        AllLabelsAcionTypes.loadAllLabelsStart,
        AllLabelsAcionTypes.loadAllLabelsSuccess
    ).toString()]: (state: AppState.AllLabelsState, action) => ({
      ...state,
      ...action.payload,
    }),
  },
  allLabelsState
);
